import React, { useEffect, useState } from "react";
import Modal from "@material-ui/core/Modal";
import {
  Box,
  CircularProgress,
  IconButton,
  TextField,
  Typography,
  makeStyles,
} from "@material-ui/core";
import ApiClient from "utils/ApiClient";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Close } from "@material-ui/icons";
import styled from "styled-components";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "600px",
    maxHeight: "90vh",
    minHeight: "50vh",
    overflow: "auto",
    backgroundColor: "white",
    boxShadow: "0 8px 32px 0 rgba( 31, 38, 135, 0.37 )",
    backdropFilter: "blur( 4.5px )",
    WebkitBackdropFilter: "blur( 4.5px )",
    borderRadius: "5px",
  },
  header: {
    position: "sticky",
    top: "0",
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    padding: "10px",
    fontSize: "20px",
    fontWeight: "bold",
    marginBottom: "10px",
    backgroundColor: "#f0f0f0",
    border: "1px solid #e0dcdc",
  },
  body:{
    fontSize: "14px",
  },
  chat: {
    padding: "10px",
    borderRadius: "5px",
    margin: "0px 10px 10px 10px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
    borderBottom: "1px solid #e0dcdc",
  },
  assistant: {
    backgroundColor: "#f0f0f0",
    padding: "10px",
    borderRadius: "5px",
    margin: "0px 10px 10px 10px",
    whiteSpace: "pre-wrap",
    borderLeft: "2px solid rgb(35, 127, 244)",
    fontSize: "14px",
  },
  user: {
    backgroundColor: "white",
    padding: "10px",
    borderRadius: "5px",
    margin: "5px 10px 10px 10px",
    fontSize: "15px",
    borderRight: "2px solid rgb(35, 127, 244)",
  },
  closeButton: {
    position: "sticky",
    top: "0",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0px 14px",
    backgroundColor: "rgb(35, 127, 244)",
    color: "white",
  },
}));

export default function SimpleModal({ openModal, closeModal, open }) {
  const [progress, setProgress] = useState({ isLoading: true, chats: [] });
  const [applyFilters, setApplyFilters] = useState({ domain: "", email: "" });

  const [chatModal, setChatModal] = useState({ open: false, chat: [], id: "" });
  const [uniqueDomains, setUniqueDomains] = useState([]);

  const handlechatModalClose = () => {
    setChatModal({ open: false, chat: [] });
  };

  const styles = useStyles();

  const handleClose = () => {
    closeModal();
  };

  const setFilter = (e, type) => {
    setApplyFilters({ ...applyFilters, [type]: e.target.value });
  };

  const setDomainFilter = (value, type) => {
    setApplyFilters({ ...applyFilters, [type]: value || "" });
  };

  const getAllChats = async () => {
    setProgress({ ...progress, isLoading: true });
    try {
      const response = await ApiClient.Assistant.getAllChats();
      setProgress({ ...progress, chats: response.data, isLoading: false });
      setUniqueDomains([...new Set(response.data.map((chat) => chat.domain))]);
    } catch (error) {
      setProgress({ ...progress, isLoading: false });
    }
  };

  const onClickChat = async (id, domain) => {
    try {
      const response = await ApiClient.Assistant.chats({ id, domain });
      const messages = window.appStore.chatStore.formatChatMessagesComingFromApi(response.data);
      setChatModal({ open: true, chat: messages, id: id });
    } catch (error) {
      setChatModal({ open: false, chat: [] });
    }
  };

  useEffect(() => {
    getAllChats();
  }, []);

  const getAutoComplete = (options, type, placeholder) => {
    return (
      <Autocomplete
        id="size-small-outlined"
        size="small"
        options={options}
        onChange={(e, value) => setDomainFilter(value, type)}
        renderInput={(params) => (
          <TextField {...params} variant="outlined" onChange={e => setFilter(e, "domain")} placeholder={placeholder} />
        )}
        renderOption={(option) => (
          <Typography style={{ fontSize: ".8rem" }} variant="p">
            {option}
          </Typography>
        )}
      />
    );
  };

  const Chat = ({ chat, onClickChat }) => {
    return (
      <div className={styles.chat} onClick={() => onClickChat(chat.id, chat.domain)}>
        <h6>
          ID : {chat.id} , Domain : {chat.domain} , User : {chat.user_email}
        </h6>
        <StyledChatContainer>
          <StyledInitialQuery>Initial query: {chat.initial_query}</StyledInitialQuery>
          <StyledCreatedAt>{chat.created_at}</StyledCreatedAt>
        </StyledChatContainer>
      </div>
    );
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className={styles.root}>
          <div>
            <div className={styles.header}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "10px",
                  width: "100%",
                }}
              >
                {getAutoComplete(uniqueDomains, "domain", "Domain")}
                <TextField
                  placeholder="Email"
                  onChange={(e) => setFilter(e, "email")}
                  variant="outlined"
                />
              </div>
              <IconButton>
                <Close onClick={handleClose} />
              </IconButton>
            </div>
            <div className={styles.body}>
              {progress.isLoading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                    marginTop: "20%",
                  }}
                >
                  <CircularProgress size={30} />
                </div>
              ) : (
                progress.chats
                  .filter((chat) => {
                    if (applyFilters.domain !== "" && applyFilters.email !== "") {
                      return (
                        chat.domain.startsWith(applyFilters.domain) &&
                        chat.user_email.startsWith(applyFilters.email)
                      );
                    }
                    if (applyFilters.domain !== "") {
                      return chat.domain.startsWith(applyFilters.domain);
                    }
                    if (applyFilters.email !== "") {
                      return chat.user_email.startsWith(applyFilters.email);
                    }
                    return true;
                  })
                  .map((chat) => {
                    return <Chat chat={chat} onClickChat={onClickChat} styles={styles} />;
                  })
              )}
            </div>
          </div>
        </Box>
      </Modal>
      {chatModal.open && (
        <Modal
          open={chatModal.open}
          onClose={handlechatModalClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <>
            <Box className={styles.root}>
              <div className={styles.closeButton}>
                <h6>Chat ({chatModal.id})</h6>
                <IconButton>
                  <Close onClick={handlechatModalClose} style={{ color: "white" }} />
                </IconButton>
              </div>
              <div>
                {chatModal.chat.map((message, index) => {
                  return (
                    <div
                      className={
                        message.role == "assistant" || message.role == "function"
                          ? styles.assistant
                          : styles.user
                      }
                      key={index}
                    >
                      {message.initial_query || message.content}
                    </div>
                  );
                })}
              </div>
            </Box>
          </>
        </Modal>
      )}
    </div>
  );
}
const StyledChatContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const StyledInitialQuery = styled.div`
  align-self: flex-start;
`;

const StyledCreatedAt = styled.div`
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
  align-self: flex-end;
`;